/*
  Cart bundle lines — quantity and remove controls for native bundle lines (Shopify Cart Transform), whichever
  app made the bundle.

  theme.js (read only) changes a line by its key. A merged bundle line's key is the parent variant plus a hash of
  its properties, so two different bundles of the same bundle product can share one, and a change "by key" then
  lands on whichever of them Shopify finds first. Shopify's answer is to target such lines by position (`line`).
  So for controls marked `data-bundle-line` (snippets/line-item.liquid) this takes the click or change first —
  the capture phase on document runs before LineItemQuantity's listeners on its own element — and sends `line`.
  Ordinary lines never reach any of this.

  The rendered position can be stale (theme.js re-renders the drawer's lines 1250ms after a change, and adds and
  removals shift positions), so it is re-resolved against a fresh /cart.js by key first: a single match is
  unambiguous; several (the shared-key case) keep the rendered position only if it is still one of them;
  anything else re-renders the cart instead of guessing.

  Drawer: one /cart/change.js, then the same line-item:change + cart:change events theme.js sends, so the line
  animates out and the drawer, count and bars update as usual. /cart page: theme.js navigates to /cart/change
  for every change there, so this does the same with `line=`.

  Also here: the "N items · View" toggle of the expandable bundle style (snippets/bundle-contents.liquid).
*/
(function () {
  'use strict';

  if (window.__cartBundleLine) return;
  window.__cartBundleLine = true;

  var HOST = 'line-item-quantity[data-bundle-line]';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var html = document.documentElement;
  /* An app proxy page (/apps/…) can't render theme sections — Shopify answers null — so render them at the root. */
  var sectionsPath = new RegExp('^' + root.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + 'apps/').test(window.location.pathname)
    ? root
    : window.location.pathname;

  function onCartPage() {
    var settings = window.themeVariables && window.themeVariables.settings;
    return !!settings && settings.pageType === 'cart';
  }

  function controls(host) {
    var selector = host.querySelector('quantity-selector');
    var buttons = selector ? selector.querySelectorAll('button.quantity-selector__button') : [];
    return {
      input: host.querySelector('input[data-line-key]'),
      minus: buttons.length ? buttons[0] : null,
      plus: buttons.length > 1 ? buttons[buttons.length - 1] : null
    };
  }

  /* The quantity the shopper asked for. `defaultValue` is the rendered quantity: the buttons' own listener
     (QuantitySelector) never ran, so the input still holds it. */
  function requested(host, trigger) {
    var parts = controls(host);
    if (!parts.input) return null;

    var current = parseInt(parts.input.defaultValue, 10) || 0;
    var max = parseInt(parts.input.getAttribute('max'), 10) || Infinity;
    var quantity;

    if (trigger === 'remove') {
      quantity = 0;
    } else if (trigger === parts.minus) {
      quantity = current - 1; /* at 1 this is the trash button, and 0 removes */
    } else if (trigger === parts.plus) {
      quantity = Math.min(current + 1, max);
    } else if (trigger === parts.input) {
      var typed = parseInt(parts.input.value, 10);
      if (isNaN(typed)) {
        parts.input.value = current;
        return null;
      }
      quantity = Math.min(Math.max(typed, 0), max);
    }

    if (quantity === undefined || quantity < 0 || quantity === current) return null;
    return { key: parts.input.getAttribute('data-line-key'), quantity: quantity };
  }

  function resolveLine(cart, key, rendered) {
    var matches = [];
    cart.items.forEach(function (item, index) {
      if (item.key === key) matches.push(index + 1);
    });
    if (matches.indexOf(rendered) !== -1) return rendered;
    return matches.length === 1 ? matches[0] : 0;
  }

  function rerender() {
    if (onCartPage()) window.location.reload();
    else html.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  async function change(host, request) {
    if (host.hasAttribute('aria-busy')) return;
    host.setAttribute('aria-busy', 'true');

    var lineItem = host.closest('line-item');
    var cartPage = onCartPage();
    if (!cartPage && lineItem) {
      lineItem.dispatchEvent(
        new CustomEvent('line-item:will-change', { bubbles: true, detail: { targetQuantity: request.quantity } })
      );
    }

    try {
      var live = await (await fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin' })).json();
      var line = resolveLine(live, request.key, parseInt(host.getAttribute('data-bundle-line'), 10));
      if (!line) throw new Error('bundle line moved');

      if (cartPage) {
        window.location.href = root + 'cart/change?line=' + line + '&quantity=' + request.quantity;
        return;
      }

      var sections = [];
      html.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));

      var response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: request.quantity, sections: sections, sections_url: sectionsPath })
      });
      var cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'cart/change ' + response.status);

      var after = cart.items[line - 1];
      var quantity = request.quantity === 0 || !after || after.key !== request.key ? 0 : after.quantity;

      if (lineItem) {
        lineItem.dispatchEvent(new CustomEvent('line-item:change', { bubbles: true, detail: { quantity: quantity, cart: cart } }));
      }

      /* CartDrawer._onCartChanged reads sections[its id] unguarded; never hand it a cart without one. */
      var drawer = document.querySelector('cart-drawer');
      var drawerSection = drawer && drawer.closest('.shopify-section');
      var drawerId = drawerSection ? drawerSection.id.replace('shopify-section-', '') : null;
      if (drawerId && !(cart.sections && cart.sections[drawerId])) {
        html.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } else {
        html.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: cart } }));
      }
    } catch (error) {
      host.removeAttribute('aria-busy');
      var loader = lineItem && lineItem.querySelector('pill-loader');
      if (loader) loader.removeAttribute('aria-busy');
      rerender();
    }
  }

  function swallow(event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  /* "N items · View": opens the contents list of the bundle line it sits in (snippets/bundle-contents.liquid).
     Delegated from document, so it outlives every drawer re-render; each re-render starts closed again. Only an
     attribute changes, never the DOM tree, so GoKwik's childList observer doesn't see it. */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-bundle-toggle]');
    if (!toggle) return;
    var line = toggle.closest('line-item');
    var list = line && line.querySelector('[data-bundle-items]');
    if (!list) return;
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    list.hidden = !open;
  });

  document.addEventListener(
    'click',
    function (event) {
      var host = event.target.closest && event.target.closest(HOST);
      if (!host) return;

      var trigger = event.target.closest('button.quantity-selector__button, a[href*="/cart/change"]');
      if (!trigger || !host.contains(trigger)) {
        /* LineItemQuantity re-posts the current quantity, by key, on any click inside the selector — the input
           included. Keep those away from it too; focusing the input is a default action and still happens. */
        if (event.target.closest('quantity-selector')) swallow(event);
        return;
      }

      event.preventDefault();
      swallow(event);
      var request = requested(host, trigger.tagName === 'A' ? 'remove' : trigger);
      if (request) change(host, request);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var host = event.target.closest && event.target.closest(HOST);
      if (!host || !event.target.matches('input[data-line-key]')) return;
      swallow(event);
      var request = requested(host, event.target);
      if (request) change(host, request);
    },
    true
  );
})();
